'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSortedLayoutIndexes = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  const layout = {
    header: [
      { id, __index },
      { id: COMB, dimensions: [{ id, __index }] }
    ],
    sections: [],
    rows: []
  }

*/

var getLayoutPivots = function getLayoutPivots(layoutEntry) {
  var valIndexGetter = function valIndexGetter(d) {
    return R.pipe(R.nth(R.prop('__index', d)), function (ind) {
      return d.isInverted ? R.negate(ind) : ind;
    });
  };
  return function (indexes) {
    return R.map(R.ifElse(R.has('dimensions'), function (c) {
      return R.map(function (d) {
        return valIndexGetter(d)(indexes);
      }, R.prop('dimensions', c));
    }, function (d) {
      if (d.id === 'OBS_ATTRIBUTES') {
        return R.last(indexes);
      }
      return valIndexGetter(d)(indexes);
    }), layoutEntry);
  };
};

var comparator = function comparator(a, b) {
  var size = R.length(a);
  var i = 0;
  while (i < size) {
    if (R.is(Array, a[i])) {
      var _a = a[i];
      var _b = b[i];
      var _size = R.length(_a);
      var j = 0;
      while (_a[j] === _b[j] && j < _size) {
        j++;
      }
      if (_a[j] !== _b[j]) {
        return _a[j] - _b[j];
      }
    } else if (a[i] !== b[i]) {
      return a[i] - b[i];
    }
    i++;
  }
  return a[i] - b[i];
};

// simple call to ramda uniq method is very slow regarding performance
var uniqIndexes = function uniqIndexes(indexes) {
  return R.pipe(R.reduce(function (acc, i) {
    var key = R.join(':', R.unnest(i));
    if (R.has(key, acc.keys)) {
      return acc;
    }
    return {
      indexes: R.append(i, acc.indexes),
      keys: R.assoc(key, key, acc.keys)
    };
  }, { indexes: [], keys: {} }), R.prop('indexes'))(indexes);
};

var getSortedLayoutIndexes = exports.getSortedLayoutIndexes = function getSortedLayoutIndexes(layout, observations) {
  var dimIndexes = R.pipe(R.values, R.map(R.propOr([], 'orderedDimIndexes')))(observations);

  var headerPivots = getLayoutPivots(layout.header);
  var sectionsPivots = getLayoutPivots(R.concat(layout.sections, layout.rows));

  var sectionLength = R.length(layout.sections);

  var _R$pipe = R.pipe(R.reduce(function (acc, indexes) {
    var headerIndexes = headerPivots(indexes);
    var sectionsIndexes = sectionsPivots(indexes);

    return {
      header: R.append(headerIndexes, acc.header),
      sections: R.append(sectionsIndexes, acc.sections)
    };
  }, { header: [], sections: [] }), R.mapObjIndexed(uniqIndexes), R.evolve({
    header: R.sort(comparator),
    sections: R.sort(comparator)
  }), function (indexes) {
    return (0, _extends3.default)({}, indexes, {
      sections: R.reduce(function (acc, i) {
        var _R$splitAt = R.splitAt(sectionLength, i),
            _R$splitAt2 = (0, _slicedToArray3.default)(_R$splitAt, 2),
            sectionIndexes = _R$splitAt2[0],
            rowIndexes = _R$splitAt2[1];

        var previousSecIndexes = R.pipe(R.nth(-1), function (i) {
          return R.isNil(i) ? null : R.head(i);
        })(acc);
        if (R.equals(R.unnest(sectionIndexes), previousSecIndexes ? R.unnest(previousSecIndexes) : null)) {
          //perhaps a bit dirty ...
          return R.over(R.lensIndex(-1), R.over(R.lensIndex(1), R.append(rowIndexes)))(acc);
        }

        return R.append([sectionIndexes, [rowIndexes]], acc);
      }, [], indexes.sections)
    });
  })(dimIndexes),
      header = _R$pipe.header,
      sections = _R$pipe.sections;

  return { header: header, sections: sections };
};